import React, { useState } from 'react'
import MessageIcon from '../../Common/svg/messageicon'
import EditPen from '../../Common/svg/editpenicon'
import StatusBadge from '../../UI/statusBadge'
import { useMutation } from 'react-query'
import { updateOrders } from '../../../MyApi/orders'
import { toast } from 'react-toastify'
import { updateStore } from '../../../MyApi/stores'
import { Spinner } from 'reactstrap'
import { useNavigate } from 'react-router-dom'



const ShippingStatusCard = ({categories,name,logo,is_closed ,id ,refetch ,statusApi}) => {
  const [isClosed,setIsClosed]=useState(0)
    const mutation =useMutation({mutationKey:["updateStoreStatus"],mutationFn:(postData)=>updateStore(postData,id),onSuccess:(data)=>{
        toast.success(`${data.message}`)
        refetch()
    }})
    const navigate =useNavigate()
    const handleChangeStatus =(e)=>{
        const checked =e.target.checked
        const formData = new FormData()
     setIsClosed(checked)
     formData.append("store[is_closed]",checked ?1:0)
      formData.append("_method","PUT")
        mutation.mutate(formData)
    }
  return (
   <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center gap-3">
              <div className="avatar">
                <img
                  className="media rounded-circle img-80 "   
                  src={logo}
                  alt={name}
                />
              </div>
              <div>
                <div className="d-flex  align-items-center  gap-3">
                  <h5>{name}</h5>
                  <StatusBadge
                    status={statusApi ?"active":""}
                  
                  />
                </div>
                <h4 className="desc font16 mt-3">{categories}</h4>
              </div>
            </div>
            <div>
              <div className="d-flex align-items-center gap-2 mb-2">
                <button className="btn btn-white" onClick={()=>navigate(`${process.env.PUBLIC_URL}/shipping/edit/${id}`)}>
                  <EditPen />
                </button>
                {/* <button className="btn btn-white">
                  <MessageIcon />
                </button> */}
              </div>
              <div className="d-flex align-items-center mt-2 gap-2">
              
            {mutation.isLoading ?<Spinner/> :    ""}
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default ShippingStatusCard